import React, { useState, useEffect } from 'react'
import ImgError from '../SVG/404Error.svg'
import { useLocale } from '../i18n/localeContext';
import {getHomepage} from '../Api/content';

function PageNotFound({message}) {
  const { locale } = useLocale();
  const [homePage, setHomePage] = useState(null);

  useEffect(() => {
    let cancel = false;
    getHomepage(locale)
      .then((res) => {
        if (cancel) return;
        const data = res?.data?.attributes || res?.data || res;
        setHomePage(data);
      });
  }, [locale]);

  return (
    <div className='error-container'>
    <div className='main-admin img-error-container'>
      <img src={ImgError} alt="Imagen Página no encontrada"></img>
    </div>
    <div className='message'>
      <h1>{homePage?.title || "Error 404 - Página no encontrada"}</h1>
    </div>
    </div>
  )
}

export default PageNotFound